<div class="add-dialog">
  <div class="ui-g">
    <div class="ui-g-12 p-zero dialog-header">
      <div class="header-bar flex-start-center">
        <div class="header-icon-columns font-20 font-gray-45">
          <i class=" fal {{customerType === 'fleet'? 'fal fa-cars': 'fal fa-user'}}"
            *ngIf="active === 'add-customer' && isSubmitVisible"></i>
          <i class="fal fa-car " *ngIf="active === 'add-vehicle' && isSubmitVisible"></i>
          <i class="fal fa-calendar-alt " *ngIf="active === 'add-appointment'"></i>
          <i class="fal fa-chevron-left  pointer" *ngIf="active === 'add-customer' && !isSubmitVisible"
            (click)="back('add-vehicle')"></i>
          <i class="fal fa-chevron-left  pointer" *ngIf="active === 'add-vehicle' && !isSubmitVisible"
            (click)="back('vehicle')"></i>
        </div>

        <div class="center-bar">
          <div class="heading-box">
            <div class="modal-heading" *ngIf="active !== 'add-appointment'">
              {{heading}}&nbsp;
              <span *ngIf="!isSubmitVisible && active === 'add-customer'">
                / {{customerType === 'fleet'? 'New fleet customer' : 'New customer'}}
              </span>
              <span *ngIf="!isSubmitVisible && active === 'add-vehicle'">/ New vehicle</span>
            </div>

            <div class="heading-appointment" *ngIf="active === 'add-appointment'">
              <div class="appointment-title-heading" *ngIf="!appointmentInputVisible && !appointment.isOpenBlockTab"
                (click)="onFocusATInput()">
                {{appointment.title}}
              </div>

              <div class="appointment-input" *ngIf="appointment.isOpenBlockTab || appointmentInputVisible">
                <app-input [id]="'appt-title'" placeholder="Add title" [value]="appointment.title" theme="secondary"
                  [disabled]="hideAppointmentTitle" [floatingLabel]="false" [maxLength]="50"
                  (appChange)="onTitleChange($event)" (appBlur)="onBlurATInput()">
                </app-input>
              </div>
            </div>
          </div>

          <div class="other">
            <i class="fal fa-trash fa-sm appointment-delete" *ngIf="appointment._id"
              (click)="appointmentDeleteBtn()"></i>

            <div class="color-control" *ngIf="active === 'add-appointment' && showColorDropdown">
              <app-color-dropdown [value]="appointment.color" [options]="appointmentColors"
                (select)="onColorChange($event)" (saveUpdateColor)="saveColorChange($event)"></app-color-dropdown>
            </div>
          </div>
        </div>

        <div class="width-45">
          <i id="close-dialog-icon" class="fal fa-times fa-sm ml-15 dialog-close" (click)="close()"></i>
        </div>
      </div>
    </div>

    <div class="ui-g-12 dialog-body">
      <span class="display-none" [ngClass]="{'display-block': active === 'add-customer'}"
        *ngIf="active === 'add-customer'">
        <app-customer-add [qboTaxExemptReasons]="qboTaxExemptReasons" [openFrom]="customerContext" [from]="from"
          [onSubmitData]="submit" [setProcessingState]="setProcessingState" [setCustomerType]="setCustomerType"
          [isProcessing]="isProcessing" [customerNameForCreate]="customerNameForCreate"
          [customerPhoneForCreate]="customerPhoneForCreate" [customerEmailForCreate]="customerEmailForCreate"
          [isOperationalNotifEnabled]="isOperationalNotifEnabled" [isMarketingNotifEnabled]="isMarketingNotifEnabled"
          (customerCreated)="customerCreated($event)" (customerCreatedForOther)="customerCreatedForOther($event)"
          (customerProcessingMode)="isCreateMode = $event;" (cancelCreatedForOther)="cancelCreatedForOther($event)"
          (fieldChanged)="changeSubmitBtnId($event)"></app-customer-add>
      </span>

      <span class="display-none h-100" [ngClass]="{'display-block': active === 'add-vehicle'}"
        *ngIf="active === 'add-vehicle'">
        <app-vehicle-add [company]="company" [openFrom]="vehicleContext" [from]="from"
          [onlineOrderSource]="onlineOrderSource" [vehicleNameForCreate]="vehicleNameForCreate"
          [setProcessingState]="setProcessingState" [isProcessing]="isProcessing" [inputCustomer]="customerForVehicle"
          [onSubmitData]="submit" [isCreateMode]="isCreateMode" [onProceedData]="proceed"
          [vehicleOnCart]="vehicleOnCart" (vehicleCreated)="vehicleCreated($event)"
          (createCustomer)="createCustomerFromOther($event)"
          (vehicleProcessingMode)="isCreateMode = $event; isProcessing = false;"
          (vehicleCreatedForOther)="vehicleCreatedForOther($event)" (closeDialog)="close()"
          (onProceedQuickTireLookup)="onProceedQuickTireLookup($event)"
          (cancelCreatedForOther)="cancelCreatedForOther($event)" [isOpenFromCreateCustomer]="isOpenFromCreateCustomer">
        </app-vehicle-add>
      </span>

      <span *ngIf="active === 'add-appointment'">
        <app-appointment [setTaxExemptReasons]="setTaxExemptReasons" [setCompanyData]="setCompanyData"
          [setAppointmentColors]="setAppointmentColors" [openFrom]="appointmentContext"
          [setProcessingState]="setProcessingState" [isProcessing]="isProcessing"
          (setCurrentCustomerLang)="setCurrentCustomerLang($event)" [inputCustomer]="customerForAppointment"
          [appointmentData]="appointment" [onSubmitData]="submit" [inputEstimate]="estimateForAppointment"
          (appointmentCreated)="appointmentCreated($event)" (createCustomer)="createCustomerFromOther($event)"
          (createVehicle)="createVehicleFromOther($event)" [isOpenFromCreateCustomer]="isOpenFromCreateCustomer">
        </app-appointment>
      </span>
    </div>

    <div class="ui-g-12 text-right dialog-footer">
      <input *ngIf="!isSubmitVisible" type="button" value="hidden" class="btn btn-transparent btn-submit opacityZero">
      <button *ngIf="isSubmitVisible" id="btn-cancel" class="btn btn-border pointer btn-submit mr-2" (click)="close()">
        Cancel
      </button>

      <button *ngIf="active === 'add-customer' && !isSubmitVisible" id="btn-cancel"
        class="btn btn-border pointer btn-submit mr-2" (click)="back('add-vehicle')">
        Cancel
      </button>

      <button *ngIf="active === 'add-vehicle' && !isSubmitVisible" id="btn-cancel"
        class="btn btn-border pointer btn-submit mr-2" (click)="back('vehicle')">
        Cancel
      </button>

      <ng-container *ngIf="from !=='quick-tire-lookup' || isCreateMode">
        <button #submitBtn id="btn-save" class="btn btn-primary btn-submit" [disabled]="isProcessing"
          (click)="onSubmit()">
          <span [ngClass]="{'pr-2': isProcessing}">{{saveButtonText}}</span>
          <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="from ==='quick-tire-lookup' && !isCreateMode">
        <button id="btn-save" class="btn btn-primary btn-submit" (click)="onProceed()">
          <span>Proceed</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>
